import { Typography } from '@mui/material';
import { connect, type ConnectedProps } from 'react-redux';
import { deleteMember } from '@/slices/members';
import { type DrawerContentProps } from '../../../state';
import { DrawerLayout } from '../../layouts';

type Props = DrawerContentProps & ConnectedProps<typeof connector>;

const DeleteMemberDrawer = ({
  closeDrawer,
  drawerData: { propertyId, memberId },
  deleteMember,
}: Props) => {
  const handleAccept = () => {
    deleteMember({ propertyId, memberId });
    closeDrawer();
  };

  return (
    <DrawerLayout
      danger
      closeDrawer={closeDrawer}
      title="Delete Member"
      onAccept={handleAccept}
      acceptText="Delete"
      onCancel={closeDrawer}
      cancelText="Cancel"
    >
      <Typography>Are you sure you want to remove this member?</Typography>
    </DrawerLayout>
  );
};

const connector = connect(null, { deleteMember });

export default connector(DeleteMemberDrawer);
